<template>
  <div class="wrapper">
    <div class="roof" @click="toDetail(firstnew.id)">
      <img :src="firstnew.cover_img+'?x-oss-process=image/resize,m_fixed,w_414'" alt="">
      <div class="content">{{firstnew.title}}</div>
    </div>
    <div class="list" v-for="(l,i) in lists" :key="i" @click="toDetail(l.id)">
      <div class="title">{{l.title}}</div>
      <div class="sub">
        <div class="subtitle">{{l.about}}</div>
        <div class="view"><img src="../../assets/images/view.png" alt=""> {{l.page_view > 999 ? Math.floor(l.page_view/100)/10+'K' : l.page_view}}</div>
      </div>
      <div class="pic">
        <img :src="l.cover_img+'?x-oss-process=image/resize,m_fixed,w_414'" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import utils from '../../utils/index'
export default {
  data(){
    return {
      data: "",
      firstnew: {},
      lists: []
    }
  },
  mounted(){
    let that = this
    let req = {
      page: 1,
      page_size: 10
    }
    let time = utils.getts()
    let token = md5("BLUE" + time + "SHARK")
    let header = {
      headers: {
        Authorization: "Bearer " + token,
        Ts: time,
        SGAGENT: PKG_NAME
      }
    }
    that.$http.post(API_HOST+"/web/api/v1/article/list",JSON.stringify(req),header).then((res)=>{
      let data = res.body
      if(data.state == 0){
        that.firstnew = data.data.list[0]
        if(data.data.list.length > 1){
          that.lists = data.data.list.slice(1)
        }
      }
    })
  },
  methods: {
    getTicket(res){
      this.data = res
    },
    toDetail(id){      
      this.$router.push("/app/find/detail/"+id)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper{
  .roof{
    position: relative;
    font-size: 0;
    img{
      width: 100%;
      // height: 300px;
    }
    .content{
      position: absolute;
      bottom: 0;
      color: #fff;
      font-size: 22px;
      font-weight: bold;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      // text-align: justify;
    }
  }
  .list{
    margin: 0 20px;
    padding: 15px 0 10px;
    border-bottom: 1px solid #ddd;
    .title{
      font-size: 17px;
      font-weight: bold;
      padding: 0 7px 5px;
    }
    .sub{
      display: flex;
      display: -webkit-flex;
      .subtitle{
        flex: 1;
        min-height: 20px;
        font-size: 14px;
        color: #969696;
        padding: 0 7px 10px;
      }
      .view{
        color: #969696;
        font-size: 12px;
        img{
          width: 22px;
          vertical-align: middle;
          margin-bottom: 3px;
        }
      }
    }
    .pic{
      font-size: 0;
      img{
        width: 100%;
        // height: 200px;
        border-radius: 8px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/find/index.vue